export default __webpack_public_path__ + "static/media/surgeryTracker_bianco.cd440603.png";